import React, { Component } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";

import { MdDragHandle } from 'react-icons/md';

const mapToSnapCase = (text) => {
  switch (text) {
    case 'slider':
      return 'Slider'
    case 'tag-discounts':
      return 'Banner Promo'
    case 'blog-newsletter':
      return 'Blog Newsletter'
    case 'special-offers':
      return 'Prodotti in sconto'
    case 'latest-bestsellers':
      return 'Più venduti'
    case 'time-limited-discount':
      return 'Offerta a tempo'
    case 'banner-carousel':
      return 'Banner Carousel'
    case 'services':
      return "Servizi"
    default:
      return text.split('-').join(' ')
  }
}

const SortableItem = SortableElement(({ value }) => (
  <li
    style={{
      height: "30px",
      lineHeight: "30px",
      borderRadius: "30px",
      margin: "10px 0",
      background: "#E7E9FE",
      color: "var(--backgroundImageColor)",
      padding: "0 20px",
      cursor: "pointer",
      listStyle: "none",
      zIndex: 1002,
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: 14
    }}
  >
    <MdDragHandle style={{ verticalAlign: "middle", marginRight: 10 }} />
    {mapToSnapCase(value)}
  </li>
));

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className="sort-list" style={{ padding: 24 }}>
      {items.map((value, index) => (
        <SortableItem key={`item-${value}`} index={index} value={value} />
      ))}
    </ul>
  );
});

class SortableComponent extends Component {
  state = {
    items: this.props.items,
  };
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
    this.props.handleChangeOrder(this.state.items)
  };
  render() {
    return <SortableList items={this.state.items} onSortEnd={this.onSortEnd} />;
  }
}

export default SortableComponent;
